// Google Analytics Event Tracking Utilities

/**
 * Send custom event to Google Analytics
 * @param {string} eventName - Name of the event
 * @param {object} eventParams - Additional parameters for the event
 */
export const trackEvent = (eventName, eventParams = {}) => {
  if (window.gtag) {
    window.gtag('event', eventName, eventParams);
    console.log(`📊 GA Event: ${eventName}`, eventParams);
  } else {
    console.warn('Google Analytics not loaded');
  }
};

/**
 * Track portfolio project clicks
 * @param {string} projectName - Name of the project clicked
 * @param {string} projectCategory - Category of the project
 */
export const trackPortfolioClick = (projectName, projectCategory = 'portfolio') => {
  trackEvent('portfolio_project_click', {
    project_name: projectName,
    category: projectCategory,
    timestamp: new Date().toISOString()
  });
};

/**
 * Track contact form submission
 * @param {string} formName - Name of the form
 * @param {boolean} success - Whether submission was successful
 */
export const trackContactFormSubmit = (formName = 'contact_form', success = true) => {
  trackEvent('contact_form_submit', {
    form_name: formName,
    success: success,
    timestamp: new Date().toISOString()
  });
};

/**
 * Track newsletter signup
 * @param {string} email - User email (hashed for privacy)
 * @param {boolean} success - Whether signup was successful
 */
export const trackNewsletterSignup = (success = true) => {
  trackEvent('newsletter_signup', {
    success: success,
    timestamp: new Date().toISOString()
  });
};

/**
 * Track chatbot interactions
 * @param {string} action - Type of interaction (open, close, message_sent)
 * @param {string} messageType - Type of message (user, bot, quick_question)
 */
export const trackChatbotInteraction = (action, messageType = null) => {
  trackEvent('chatbot_interaction', {
    action: action,
    message_type: messageType,
    timestamp: new Date().toISOString()
  });
};

/**
 * Track page views manually (for SPAs)
 * @param {string} pageName - Name/path of the page
 */
export const trackPageView = (pageName) => {
  if (window.gtag) {
    window.gtag('config', 'G-XXXXXXXXXX', {
      page_path: pageName,
    });
  }
};

/**
 * Track resume download
 */
export const trackResumeDownload = () => {
  trackEvent('resume_download', {
    timestamp: new Date().toISOString()
  });
};

/**
 * Track social link clicks
 * @param {string} platform - Social media platform (linkedin, github, twitter)
 */
export const trackSocialClick = (platform) => {
  trackEvent('social_link_click', {
    platform: platform,
    timestamp: new Date().toISOString()
  });
};

/**
 * Track scroll depth
 * @param {number} percentage - Percentage scrolled (25, 50, 75, 100)
 */
export const trackScrollDepth = (percentage) => {
  trackEvent('scroll_depth', {
    percentage: percentage,
    timestamp: new Date().toISOString()
  });
};
